function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../locales/keys';
import { CurrentGiftCardIdSelector, CurrentGiftCardSelector, IsLoadingDataSelector } from '../../reducers/selectors/giftcard.result.selectors';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../customer/ewallet/ewallet.constants';
import { stateGo } from 'redux-ui-router';
import { RouteState } from '../../reducers/selectors/customer.selectors';
import { getGiftCardResult } from '../../reducers/actions/giftcard.result.actions';
import { setSelectedTypeId } from '../../reducers/actions/customer.ewallet.actions';
var GiftCardController = /*#__PURE__*/function () {
  function GiftCardController($ngRedux, $filter, $timeout) {
    var _this = this;
    _classCallCheck(this, GiftCardController);
    this.$ngRedux = $ngRedux;
    this.$filter = $filter;
    this.$timeout = $timeout;
    this.CustomerCareLocaleKeys = LocaleKeys;
    this.optionalParams = {};
    this.modalPopupConfig = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.modalPopupApi = api;
      }
    };
    this.openModalPopup = this.openModalPopup.bind(this);
    this.closeModalPopup = this.closeModalPopup.bind(this);
    this.onSubmitModalPopup = this.onSubmitModalPopup.bind(this);
  }
  return _createClass(GiftCardController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        retrieveGiftCard: getGiftCardResult,
        setSelectedTypeId: setSelectedTypeId,
        stateGo: stateGo
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentGiftCard: CurrentGiftCardSelector(store),
          currentGiftCardId: CurrentGiftCardIdSelector(store),
          isLoadingData: IsLoadingDataSelector(store),
          routeState: RouteState(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.stateOrName = this.state.routeState.name;
      this.retrieveGiftCard();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
      this.modalPopupApi.close();
    }
  }, {
    key: "retrieveGiftCard",
    value: function retrieveGiftCard() {
      var _this3 = this;
      this.actions.retrieveGiftCard(this.state.currentGiftCardId).then(function () {
        _this3.selectedGiftCard = _this3.state.currentGiftCard;
      });
    }
  }, {
    key: "closeModalPopup",
    value: function closeModalPopup(hasResent) {
      this.modalPopupApi.close();
      this.showModalPopup = false;
      if (hasResent) {
        this.retrieveGiftCard();
      }
    }
  }, {
    key: "onSubmitModalPopup",
    value: function onSubmitModalPopup() {
      this.closeModalPopup();
    }
  }, {
    key: "openModalPopup",
    value: function openModalPopup() {
      var _this4 = this;
      this.showModalPopup = true;

      // This $timeout is necessary as it allows for a digest cycle to occur, which properly appends the content of the modal component that was ng-if'ed into the DOM
      this.$timeout(function () {
        _this4.modalPopupApi.open();
      });
    }
  }, {
    key: "shouldShowResendActivationMessageButton",
    value: function shouldShowResendActivationMessageButton() {
      return this.selectedGiftCard && !this.selectedGiftCard.ProviderCode && !this.selectedGiftCard.Redeemed;
    }
  }, {
    key: "handleSubscriberClick",
    value: function handleSubscriberClick(subscriberId) {
      this.actions.setSelectedTypeId(Number.parseInt(SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD, 10));
      this.actions.stateGo('index.customercare.customer.ewallet', {
        customerId: subscriberId
      });
    }
  }]);
}();
export default {
  bindings: {},
  template: require('./gift.card.html'),
  controller: GiftCardController
};